"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$ = exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$outboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$inboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$ = exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$outboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$inboundSchema = void 0;
exports.getOutcodeLocationOutcodesOutcodeLocationGetSecurityToJSON = getOutcodeLocationOutcodesOutcodeLocationGetSecurityToJSON;
exports.getOutcodeLocationOutcodesOutcodeLocationGetSecurityFromJSON = getOutcodeLocationOutcodesOutcodeLocationGetSecurityFromJSON;
exports.getOutcodeLocationOutcodesOutcodeLocationGetRequestToJSON = getOutcodeLocationOutcodesOutcodeLocationGetRequestToJSON;
exports.getOutcodeLocationOutcodesOutcodeLocationGetRequestFromJSON = getOutcodeLocationOutcodesOutcodeLocationGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$;
(function (GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$) {
    /** @deprecated use `GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$inboundSchema` instead. */
    GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$.inboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$inboundSchema;
    /** @deprecated use `GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$outboundSchema` instead. */
    GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$.outboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$outboundSchema;
})(GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$ || (exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$ = GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$ = {}));
function getOutcodeLocationOutcodesOutcodeLocationGetSecurityToJSON(getOutcodeLocationOutcodesOutcodeLocationGetSecurity) {
    return JSON.stringify(exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$outboundSchema.parse(getOutcodeLocationOutcodesOutcodeLocationGetSecurity));
}
function getOutcodeLocationOutcodesOutcodeLocationGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodeLocationOutcodesOutcodeLocationGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetOutcodeLocationOutcodesOutcodeLocationGetSecurity' from JSON`);
}
/** @internal */
exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$inboundSchema = z.object({
    outcode: z.string(),
});
/** @internal */
exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$outboundSchema = z.object({
    outcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodeLocationOutcodesOutcodeLocationGetRequest$;
(function (GetOutcodeLocationOutcodesOutcodeLocationGetRequest$) {
    /** @deprecated use `GetOutcodeLocationOutcodesOutcodeLocationGetRequest$inboundSchema` instead. */
    GetOutcodeLocationOutcodesOutcodeLocationGetRequest$.inboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$inboundSchema;
    /** @deprecated use `GetOutcodeLocationOutcodesOutcodeLocationGetRequest$outboundSchema` instead. */
    GetOutcodeLocationOutcodesOutcodeLocationGetRequest$.outboundSchema = exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$outboundSchema;
})(GetOutcodeLocationOutcodesOutcodeLocationGetRequest$ || (exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$ = GetOutcodeLocationOutcodesOutcodeLocationGetRequest$ = {}));
function getOutcodeLocationOutcodesOutcodeLocationGetRequestToJSON(getOutcodeLocationOutcodesOutcodeLocationGetRequest) {
    return JSON.stringify(exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$outboundSchema.parse(getOutcodeLocationOutcodesOutcodeLocationGetRequest));
}
function getOutcodeLocationOutcodesOutcodeLocationGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodeLocationOutcodesOutcodeLocationGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetOutcodeLocationOutcodesOutcodeLocationGetRequest' from JSON`);
}
//# sourceMappingURL=getoutcodelocationoutcodesoutcodelocationget.js.map